import React, { useState, useEffect } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import AdminStatusClientsBody from './AdminStatusClientsBody';

export default function AdminLiveClientsScreen({ locStrings, isAdmin }) {
    return (
        <div>
            <PageHeader title="Live Clients" />
            <AdminStatusClientsBody status="live" locStrings={locStrings} isAdmin={isAdmin} />
        </div>
    );
}